// Maps a resolved route to the GA4 page_viewed dimensions. Pathname-prefix
// based (stable across both the _authed and _public route trees, which
// share URL space); page_id comes from the leaf match's params so it is
// the clean route param, not a string-parsed segment.

export type PageType =
  | 'circle'
  | 'network'
  | 'group'
  | 'event'
  | 'resource'
  | 'profile'
  | 'feed'
  | 'directory'
  | 'onboarding'
  | 'settings'
  | 'messages'
  | 'other';

const PREFIX_TO_TYPE: ReadonlyArray<[prefix: string, type: PageType]> = [
  ['/circles', 'circle'],
  ['/networks', 'network'],
  ['/groups', 'group'],
  ['/events', 'event'],
  ['/resources', 'resource'],
  ['/members', 'profile'],
  ['/feed', 'feed'],
  ['/directory', 'directory'],
  ['/onboarding', 'onboarding'],
  ['/settings', 'settings'],
  ['/messages', 'messages'],
];

export function resolvePageMeta(
  pathname: string,
  params: Record<string, string>,
): { page_type: PageType; page_id: string | null } {
  const match = PREFIX_TO_TYPE.find(
    ([prefix]) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
  if (!match) return { page_type: 'other', page_id: null };
  return { page_type: match[1], page_id: params.id ?? null };
}
